import React, { useMemo, useState } from 'react'
import Select from 'react-select'
import { Td, Tr } from '../table'
import style from '../fast-configuration-modal/fastConfigurationModal.css'
import useTranslation from '../../hooks/useTranslation'
import EquipmentGroup from '../../entities/EquipmentGroup'
import EquipmentFamily from '../../entities/EquipmentFamily'
import Equipment from '../../entities/Equipment'

interface ColorOption {
    value: string
    label: string
}

const FastConfigurationInteriorAutocomplete = ({ equipmentGroups, selectedInteriorColor, selectedModel, setSelectedInteriorColor, isLoading }) => {
    const { t } = useTranslation()
    const [interiorInputValue, setInteriorInputValue] = useState('')

    const interiorColorOptions: ColorOption[] = useMemo(() => {
        const colorSet = new Set<string>()
        equipmentGroups
            .flatMap((group: EquipmentGroup) => group.equipmentFamilies)
            .flatMap((family: EquipmentFamily) => family.equipments)
            .filter((equipment: Equipment) => equipment.id.startsWith('F56') || equipment.id.startsWith('K-'))
            .forEach((equipment: Equipment) => {
                const label = equipment.id
                colorSet.add(label)
            })
        return Array.from(colorSet).map((label): ColorOption => ({ value: label, label }))
    }, [equipmentGroups])

    const filteredInteriorColorOptions = useMemo(() => interiorInputValue.length >= 2
        ? interiorColorOptions.filter(option =>
            (option.label as string).toLowerCase().includes(interiorInputValue.toLowerCase()),
          )
        : [], [interiorInputValue, interiorColorOptions])

    return (
        <Tr>
            <Td className={style.noBorder}>
                <div className={style.explanationContainer}>
                    <h4 className={style.explanationHeading}>
                        {t('fastConfigurationModal.interiorTitle')}
                    </h4>
                    <span className={style.explanation}>
                        {t('fastConfigurationModal.interiorExplanation')}
                    </span>
                </div>
            </Td>
            <Td className={style.noBorder}>
                    <Select
                        options={filteredInteriorColorOptions}
                        value={selectedInteriorColor}
                        onChange={(selected) => setSelectedInteriorColor(selected || null)}
                        onInputChange={(value) => setInteriorInputValue(value)}
                        isSearchable
                        isClearable
                        placeholder=""
                        className={style.input}
                        classNamePrefix="fastConfig"
                        isDisabled={isLoading || selectedModel == null}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        noOptionsMessage={() =>
                            interiorInputValue.length < 2
                                ? t('fastConfigurationModal.atLeastTwoCharacters')
                                : t('fastConfigurationModal.noInteriorColor')
                        }
                    />
            </Td>
        </Tr>
    )
}

export default FastConfigurationInteriorAutocomplete
